export default "__VITE_ASSET__K00F9tBA__"